import { all, call, put, takeLatest } from "redux-saga/effects";
import {
    fetchBalanceFailure,
    fetchBalanceSuccess,
    fetchOrderFailure,
    fetchOrderSuccess,
    fetchUserFailure,
    fetchUserSuccess,
    fetchCancelFailure,
    fetchCancelSuccess
} from "./action";
import{
    FETCH_CONFIRM_REQUEST,
    FETCH_CURRENTBALANCE_REQUEST,
    FETCH_ORDER_REQUEST,
    FETCH_USER_REQUEST,
    FETCH_CANCEL_REQUEST
}from "./actionTypes"
import baseApi from "./api";
function* fetchCancelSaga({body}:any):any{
    try{
        const res = yield call(
            baseApi.fetchCancelCustomPackage,
            body || {}
        )
        yield put( 
            fetchCancelSuccess()
        )
        if(res.message ==="Ok"){
            window.location.reload()
        }
    } catch(err){
            fetchCancelFailure({
                error: ''
            })
    }
}
function* fetchConfirmSaga({params}:any):any{
    try {
        const res = yield call(
            baseApi.fetchConfirmStatus,
            params || ''
        )
        if( res.message ==="Ok"){
            // window.open("/admin/order-management")
            // window.location.reload()
        }
    } catch (error) {
        console.log(error)
    }
}
function* fetchBalanceSaga({params}:any):any{
    try {
        const res=  yield call(
            baseApi.fetchCurrentBalance,
            params || ''
        )
        yield put(
         fetchBalanceSuccess({
            currentBalance: res.result
         })
        )
    } catch (error) {
        fetchBalanceFailure({
            error: ""
        })
    }
}
function* fetchUserSaga({params}:any):any{
    try {
        const res = yield call(
            baseApi.fetchUserList,
            params || ''
        )
        yield put(
            fetchUserSuccess({
                userResult: res.result,
                totalPageUser: res.meta.pages
            })
        )
    } catch (error) {
        yield put(
            fetchUserFailure({
                error: "",
            }),
        );
    }
}
function* fetchOrderSaga({params}:any):any{
    console.log(params)
    try{
        const res = yield call(
            baseApi.fetchOrderList,
            params || ''
        )
        yield put(
            fetchOrderSuccess({
                orderResult: res.result,
                totalPageOrder: res.meta.pages
            })
        )
    } catch (error){
        yield put(
            fetchOrderFailure({
                error:""
            })
        )
    }
}

function* toCustomerSaga(){
    yield all([takeLatest(FETCH_ORDER_REQUEST, fetchOrderSaga)]);
    yield all([takeLatest(FETCH_USER_REQUEST, fetchUserSaga)]);
    yield all([takeLatest(FETCH_CURRENTBALANCE_REQUEST, fetchBalanceSaga)]);
    yield all([takeLatest(FETCH_CONFIRM_REQUEST, fetchConfirmSaga)]);
    yield all([takeLatest(FETCH_CANCEL_REQUEST, fetchCancelSaga)]);
}
export default toCustomerSaga;